import React from 'react';
import PropTypes, { object } from 'prop-types';
import { Dialog } from '@headlessui/react';
import classNames from 'classnames';
import styles from './modal.module.scss';

const Modal = ({ isOpen, isClose, children, floatRight, width, height, minWidth, padding }) => {
  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={isClose}
        className={classNames(floatRight ? styles.modal2 : styles.modal)}>
        <div
          className={classNames(floatRight ? styles.modal__content2 : styles.modal__content)}
          style={{
            width: `${width}px`,
            minHeight: `${height}px`,
            minWidth: `${minWidth}px`,
            padding: `${padding}px`
          }}>
          <div>{children}</div>
        </div>
      </Dialog>
    </div>
  );
};

Modal.defaultProps = {
  isClose: object,
  children: React.ReactNode,
  width: ''
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  isClose: PropTypes.func,
  children: PropTypes.string,
  floatRight: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.number,
  minWidth: PropTypes.number,
  padding: PropTypes.number
};

export default Modal;
